import actionTypes from '../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.ShowChartPage.set,
  data,
});
export const loadChartAction = (data) => ({
  type: actionTypes.ShowChartPage.loadChart,
  data,
});
export const createChartAction = (data) => ({
  type: actionTypes.ShowChartPage.createChart,
  data,
});
export const duplicateChartAction = (data) => ({
  type: actionTypes.ShowChartPage.duplicateChart,
  data,
});
export const editChartAction = (data) => ({
  type: actionTypes.ShowChartPage.editChart,
  data,
});
export const createLayoutAction = (data) => ({
  type: actionTypes.ShowChartPage.createLayout,
  data,
});
export const createTableAction = (data) => ({
  type: actionTypes.ShowChartPage.createTable,
  data,
});
